
(function(){
  var sliderSelector = [
    '.spin-services-grid',
    '.spin-web-grid',
    '.spin-industries-grid',
    '.spin-process-grid',
    '.spin-book-row',
    '.spin-capability-grid',
    '.spin-clean-outcome-grid',
    '.spin-deliverables',
    '.spin-map-grid',
    '.spin-leadcase-overview-grid',
    '.spin-leadcase-grid',
    '.spin-ecomcase-overview-grid',
    '.spin-ecomcase-grid',
    '.spin-results-case-grid',
    '.spin-webcase-metric-board',
    '.spin-results-card-grid',
    '.spin-ecomcase-metric-grid',
    '.spin-webcase-video-grid',
    '.spin-example-gallery-grid'
  ].join(',');

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function buildHint(track){
    if(track.dataset.spinSliderHint === 'true') return;
    var items = Array.prototype.filter.call(track.children, function(child){
      return child.nodeType === 1 && !child.classList.contains('spin-mobile-slider-hint');
    });
    if(items.length < 2) return;

    var hint = document.createElement('div');
    hint.className = 'spin-mobile-slider-hint';
    hint.setAttribute('aria-hidden', 'true');

    var label = document.createElement('span');
    label.textContent = 'Swipe';

    var dots = document.createElement('span');
    dots.className = 'spin-mobile-slider-hint__dots';

    var dotCount = Math.min(items.length, 5);
    for(var i = 0; i < dotCount; i++){
      var dot = document.createElement('span');
      dot.className = 'spin-mobile-slider-hint__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(dot);
    }

    hint.appendChild(label);
    hint.appendChild(dots);

    if(track.nextElementSibling && track.nextElementSibling.classList.contains('spin-mobile-slider-hint')){
      track.dataset.spinSliderHint = 'true';
      return;
    }
    track.insertAdjacentElement('afterend', hint);
    track.dataset.spinSliderHint = 'true';

    function updateDots(){
      var max = Math.max(1, track.scrollWidth - track.clientWidth);
      var progress = Math.min(1, Math.max(0, track.scrollLeft / max));
      var active = Math.round(progress * (dotCount - 1));
      Array.prototype.forEach.call(dots.children, function(dot, index){
        dot.classList.toggle('is-active', index === active);
      });
    }

    track.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
  }

  function enhanceMobileSliders(){
    if(!mobileQuery.matches) return;
    document.querySelectorAll(sliderSelector).forEach(function(track){
      if(track.scrollWidth > track.clientWidth + 20 || track.children.length > 1){
        buildHint(track);
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', enhanceMobileSliders);
  } else {
    enhanceMobileSliders();
  }

  if(mobileQuery.addEventListener){
    mobileQuery.addEventListener('change', enhanceMobileSliders);
  }
})();
